<template>
  <div>
    <div class="page_title">编辑问题类型</div>
    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <div class="addbox">
          <div>
            <span>问题类型</span>
            <el-input
              v-model="addData.title"
              style="width:200px;margin:0 20px 0 10px"
              placeholder="10个字以内"
              maxlength="10"
            ></el-input>
            <span>
              <span>问题分组</span>
              <el-select
                v-model="addData.group_type_id"
                placeholder="请选择"
                @change="getList"
                style="width:200px;margin:0 10px"
              >
                <el-option
                  v-for="item in groupTypeList"
                  :key="item.group_type_id"
                  :label="item.group_type_name"
                  :value="item.group_type_id"
                >
                </el-option>
              </el-select>
            </span>
            <el-button
              type="primary"
              size="medium"
              @click="saveType"
            >保存</el-button>
          </div>
          <div>
            <el-button
              type="primary"
              @click="addQue"
              style="width:110px"
            >添加问题</el-button>
            <el-button
              plain
              @click="back"
              style="width:100px"
            >返回</el-button>
          </div>
        </div>
        <div style="border: solid 1px #c9cbd6;">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%;min-width:1000px;"
            :header-cell-style="{background:'#F5F5F5'}"
          >
            <el-table-column
              label="问题题目"
              prop="title"
            ></el-table-column>

            <el-table-column
              label="修改时间"
              prop="update_time"
            ></el-table-column>

            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  @click="edit(scope.row.art_id)"
                  type="text"
                  size="medium"
                >编辑</el-button>
                <el-button
                  @click="delQue(scope.row.art_id)"
                  type="text"
                  size="medium"
                >删除</el-button>
              </template>
            </el-table-column>

            <el-table-column label="排序">
              <template slot-scope="scope">
                <el-button
                  @click="updateSort(scope.$index,1)"
                  size="medium"
                  type="text"
                  icon="el-icon-upload2"
                  style="font-size:20px"
                ></el-button>

                <el-button
                  @click="updateSort(scope.$index,2)"
                  size="medium"
                  type="text"
                  icon="el-icon-download"
                  style="font-size:20px"
                ></el-button>

                <el-button
                  @click="updateSort(scope.$index,3)"
                  size="medium"
                  type="text"
                  icon="el-icon-top"
                  style="font-size:20px"
                ></el-button>
                <el-button
                  @click="updateSort(scope.$index,4)"
                  size="medium"
                  type="text"
                  icon="el-icon-bottom"
                  style="font-size:20px"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import imgtext from '../../../api/imgtext';
import platform from '../../../api/platform';
export default {
  data() {
    return {
      detail: {},
      tableData: [],
      title: this.$route.query.title,
      addData: {},
      groupTypeList: []
    };
  },

  methods: {
    //获取问题分组列表配置
    getGroupTypeList() {
      this.axios
        .post('platform/article/getArticleGroupTypeList')
        .then((res) => {
          if (res.code == 0) {
            this.groupTypeList = res.data.list;
          }
        });
    },
    //获取详情
    getArticleGroupInfo() {
      let group_id = this.$route.query.group_id;
      this.axios
        .post('platform/article/getArticleGroupInfo', { group_id })
        .then((res) => {
          if (res.code == 0) {
            let info = res.data.info;
            this.addData = {
              group_id: info.group_id,
              group_type_id: Number(info.group_type_id),
              title: info.title
            };
          }
        });
    },
    //获取常见问题的item列表
    getList() {
      let group_id = this.$route.query.group_id;
      imgtext.getArticleList({ group_id }).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.list.map((item) => {
            item.update_time = platform.timestampToTime(item.update_time);
            return item;
          });
        }
      });
    },
    //排序
    updateSort(index, status) {
      let data = this.tableData[index];
      this.tableData.splice(index, 1);
      //置顶
      if (status == 1) {
        this.tableData.splice(0, 0, data);
      }
      //置底
      if (status == 2) {
        this.tableData.push(data);
      }
      //上移
      if (status == 3) {
        this.tableData.splice(index - 1, 0, data);
      }
      //下移
      if (status == 4) {
        this.tableData.splice(index + 1, 0, data);
      }
      let list = [];
      list = this.tableData.map((item) => {
        item = _.pick(item, ['art_id', 'sort']);
        return item;
      });
      imgtext.editArticleSort({ list }).then((res) => {
        if (res.code == 0) {
          this.getList();
        }
      });
    },
    //添加问题并跳转
    addQue() {
      if (!this.addData.title) {
        this.$router.push({
          path: 'addquestion',
          query: {
            group_id: this.$route.query.group_id
          }
        });
        return false;
      } else {
        let data = this.addData;
        imgtext.saveArticleGroupInfo(data).then((res) => {
          if (res.code == 0) {
            this.$router.push({
              path: 'addquestion',
              query: {
                group_id: this.$route.query.group_id
              }
            });
          }
        });
      }
    },
    //编辑问题
    edit(art_id) {
      this.$router.push({
        path: 'addquestion',
        query: {
          art_id,
          group_id: this.$route.query.group_id
        }
      });
    },
    //保存问题类型  分组
    saveType() {
      if (!this.addData.title) {
        this.$message.error('请填写完整再提交');
        return false;
      }
      let data = this.addData;
      imgtext.saveArticleGroupInfo(data).then((res) => {
        if (res.code == 0) {
          this.$message.success('保存成功');
          this.addDia = false;
          this.getArticleGroupInfo();
        }
      });
    },
    //删除问题
    delQue(art_id) {
      this.$confirm('确定要删除吗？', '提示消息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        imgtext
          .deleteArticleInfo({ art_id })
          .then((res) => {
            if (res.code == 0) {
              this.$message.success('删除成功');
              this.getList();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    //问题类型item
    toDetail(group_id, title) {
      this.$router.push({
        path: 'questionitem',
        query: {
          group_id,
          title
        }
      });
    },
    back() {
      history.back();
    }
  },
  created() {
    this.getList();
    this.getGroupTypeList();
    this.getArticleGroupInfo();
  }
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  padding: 20px;
  text-align: left;
}
.addbox {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
</style>

